import React from 'react'

import { TiposSocioConstant } from 'constants/index'

import { Select2Cliente, Select2Proveedor, Select2SocioOtros } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

const SocioFormGroup = ({ tipoSocio, onChange, nombreSocio, clickClear }) => {
  return (
    <>
      {nombreSocio ? (
        <ClearInputGroup id='socio-seleccionado' iValue={nombreSocio} clickClear={clickClear} />
      ) : (
        <>
          {tipoSocio === TiposSocioConstant.CLIENTE && <Select2Cliente id='select2-cliente' onChange={onChange} />}
          {tipoSocio === TiposSocioConstant.PROVEEDOR && <Select2Proveedor id='select2-proveedor' onChange={onChange} />}
          {tipoSocio === TiposSocioConstant.OTROS && <Select2SocioOtros id='select2-otros' onChange={onChange} />}
        </>
      )}
    </>
  )
}

export default React.memo(SocioFormGroup)
